<template>
  <div class="number">
    <div>
      <div v-if="pand == 0">
        <el-button type="primary" @click="onSubmit = true">添加</el-button>
      </div>
      <div v-else-if="pand == 1">
        <el-button type="primary" @click="onSubmit = true">修改</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border

      style="width: 100%; margin-top: 2.0rem"
    >
      <el-table-column
        prop="name"
        label="审批流名称"
        style="width: 10%"
      ></el-table-column>

      <el-table-column
        prop="types"
        label="关联对象"
        style="width: 20%"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="流程说明"
        style="width: 20%"
      ></el-table-column>
      <el-table-column prop="createtime" label="创建时间" style="width: 20%">
        <template slot-scope="scope">
          <div>{{ (scope.row.createtime * 1000) | formatDate }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="updatetime" label="更新时间" style="width: 20%">
        <template slot-scope="scope">
          <div>{{ (scope.row.createtime * 1000) | formatDate }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" style="width: 50%">
        <template slot-scope="scope">
          <el-tag  size="mini" v-if="scope.row.status == 1">启用</el-tag>
            <el-tag  size="mini" v-if="scope.row.status == 0">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            @click="(onSubmits = true), bianji(scope)"
            type="text"
            size="mini"
            >审批步骤</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
        <pagination
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          :page-sizes="[10,20,50,100]"
          :auto-scroll="false"
          @pagination="userTable"
        />
      </div>
    <el-dialog title="修改" center :visible.sync="onSubmit" width="30%">
      <!-- <div class="bule"></div> -->

      <el-form ref="form" :model="form" label-width="12.0rem">
        <el-form-item label="审批流名称">
          <el-input clearable v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="流程说明">
          <el-input clearable v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
        <el-button type="primary" @click="modification()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  name: "number",
  data() {
    return {
      tableData: [],
      tooken: [],
      onSubmit: false,
      form: {
        name: "",
        remark: "",
        status: "1",
      },
      pand: "",
      total:0,
      listQuery: {
        page: 1,
        limit: 20,
      },
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.userTable();
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    modification() {
      this.axios
        .post(
          "/crm/ExamineFlow/addEditFlow",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            types: "回款",
            name: this.form.name,
            remark: this.form.remark,
            status: this.form.status,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }

          // console.log(this.pand);
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
        })
        .catch(function (err) {});
    },
    bianji() {
      this.$router.push({
        name: "userExamine",
        query: {
          tableData: this.tableData,
        },
      });
    },
    userTable() {
      this.axios
        .post(
          "/crm/ExamineFlow/getList",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
            types: "回款",
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          // console.log("回款",res.data.code);
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.pand = res.data.code;
          this.tableData = res.data.data;
          this.form.name = this.tableData[0].name;
          this.form.remark = this.tableData[0].remark;
          this.form.status = this.tableData[0].status.toString();
          this.total = res.data.count
        })
        .catch(function (err) {});
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
